import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { AIAssistant } from "./AIAssistant";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { usePermissions } from "@/context/PermissionsContext";
import { useAuth } from "@/context/AuthContext";
import { SidebarProvider } from "@/context/SidebarContext";
import { useLocation } from "react-router-dom";
import { DataTrustBanner } from "@/components/common/DataTrustBanner";
import { moduleForPath } from "@/lib/provenance";

export function AppLayout({ title, subtitle, actions, children }) {
  const { canSee, role } = usePermissions();
  const { isImpersonating } = useAuth();
  const location = useLocation();
  const showAI = canSee ? canSee("ai_assistant") : true;
  const offset = isImpersonating ? "pt-11" : "";
  const moduleKey = moduleForPath(location.pathname);
  const canManage = ["admin", "executive"].includes((role || "").toLowerCase());
  return (
    <SidebarProvider>
      <div className={`min-h-screen bg-slate-50 ${offset}`}>
        <ImpersonationBanner />
        <Sidebar />
        <TopBar title={title} subtitle={subtitle} actions={actions} />
        <main className="lg:ml-64 px-3 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
          {/* Mobile action bar — actions shown below the title on narrow viewports */}
          {actions && (
            <div className="sm:hidden mb-4 flex items-center gap-2 flex-wrap">
              {actions}
            </div>
          )}
          <div className="max-w-[1400px] mx-auto">
            <DataTrustBanner moduleKey={moduleKey} canManage={canManage} />
            {children}
          </div>
        </main>
        {showAI && <AIAssistant />}
      </div>
    </SidebarProvider>
  );
}
